import { pages } from "../../utils/common";
import { IAppNavigationMenuItem } from "./components.interfaces";

const generateNavigationItem = (pageItem: any): IAppNavigationMenuItem => {
  return {
    title: pageItem.title,
    ...(pageItem.icon && { icon: pageItem.icon }),
    pageToNavigate: pageItem.path,
    ...(pageItem?.subPages &&
      Object.keys(pageItem.subPages).length > 0 && {
        subPages: Object.values(pageItem.subPages).map(generateNavigationItem),
      }),
  };
};

/**
 * Returns institute-level navigation items (Dashboard, Institute, Branding, Localization)
 * Branding and localization are institute-scoped and accessible from institute navigation per Epic 8.
 */
export const getInstituteLevelNavigation = (): IAppNavigationMenuItem[] => {
  return [
    generateNavigationItem(pages.dashboard),
    generateNavigationItem(pages.institute),
    generateNavigationItem(pages.branding),
    generateNavigationItem(pages.localization),
  ];
};

/**
 * Returns configuration navigation items (all other pages)
 */
export const getConfigurationNavigation = (): IAppNavigationMenuItem[] => {
  return [
    generateNavigationItem(pages.spocPremise),
    generateNavigationItem(pages.compliance),
    generateNavigationItem(pages.academics),
    generateNavigationItem(pages.material),
    generateNavigationItem(pages.assessment),
    generateNavigationItem(pages.users),
    generateNavigationItem(pages.rbac),
    generateNavigationItem(pages.auditTrail),
  ];
};

/**
 * Returns all primary navigation items (for backward compatibility)
 */
export const getPrimaryNavigation = (): IAppNavigationMenuItem[] => {
  return [...getInstituteLevelNavigation(), ...getConfigurationNavigation()];
};

export const getSecondaryNavigation = (): IAppNavigationMenuItem[] => {
  return [
    generateNavigationItem(pages.help),
    generateNavigationItem(pages.profile),
    generateNavigationItem(pages.logout),
  ];
};
